const stats = [
  { value: 500, suffix: "+", label: "לקוחות מרוצים" },
  { value: 13, suffix: "", label: "שנות ניסיון" },
  { value: 100, suffix: "%", label: "אחריות על העבודה" },
];

const SocialProof = () => {
  return (
    <section className="relative py-16 bg-dark overflow-hidden">
      <div className="absolute inset-0 bg-grid-gold opacity-30" aria-hidden="true" />
      <div
        className="absolute -top-24 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full bg-primary/10 blur-3xl"
        aria-hidden="true"
      />
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto text-center">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="group flex flex-col items-center p-6 rounded-2xl border border-primary/10 bg-dark/40 backdrop-blur-sm"
            >
              <span className="flex h-[3.75rem] min-w-[6.5ch] items-center justify-center text-center text-5xl md:h-[4.5rem] md:text-6xl font-bold text-gradient-gold-static mb-2 tabular-nums tracking-normal whitespace-nowrap" dir="ltr">
                {stat.suffix === "+" ? `${stat.suffix}${stat.value}` : `${stat.value}${stat.suffix}`}
              </span>
              <span className="text-dark-foreground/90 text-lg font-medium">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
